import React, {memo} from "react";
import {Button, Modal} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeDataWallet, handelCloseModalMyWallet, actionChangeLoaderMyWallet} from "../../../../../redux/actions/modals/modalMyWallet";
import TitlesModals from "../TitlesModals";
import {actionChangeHandelModalAddPrice} from "../../../../../redux/actions/modals/modalAddPrice";
import axios from "axios";
import {BASE_URL, USERS_TRANSACTIONS_POST, EXCHANGE_CARROT, USERS_CARROT_TRANSACTIONS_POST, PUBLIC_URL_SERVER} from "../../../../../apis";
import qs from "querystring";
import InfiniteScroll from 'react-infinite-scroll-component';

import LoaderModals from "../../loaders/LoaderModals";
import {FaPlus, FaTimesCircle} from "react-icons/all";
import ic_carrot from "../../../../../images/icons/ic_carrot_36.png";
import {FaInfoCircle} from "react-icons/all";
import Swal from 'sweetalert2';

import {
    actionChangeDataCarrotWallet,
    actionChangeLoaderMyCarrotWallet,
    handelOpenModalMyCarrotWallet
} from "../../../../../redux/actions/modals/modalMyCarrotWallet";


const ModalMyWallet = () => {
    const dispatch = useDispatch()
    const {statusShow, transactions, total, total_rows, offset,loader, carrot} = useSelector(state => state.modalMyWallet);
    const {token} = useSelector(state => state.user);
    const handleClose = () => {
        dispatch(handelCloseModalMyWallet());
    };
    const handelAddPrice = () => {
        // handleClose();
        // dispatch(actionChangeHandelModalAddPrice(true));
        btnOkSingle.fire({
            text: "کاربر عزیز لطفا موقتا از طریق کارت به کارت پرداخت نمایید.",
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'هشدار',
            confirmButtonText: "باشه",
        });
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });

    const handelCarrotExchange = () => {
        if(parseInt(carrot.inventory) >= parseInt(carrot.carrot_unit)) {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                    cancelButton: 'base-btn-green-border btn btn-success',
                },
                buttonsStyling: false
            });

            swalWithBootstrapButtons.fire({
                html: "تبدیل  " + Math.floor((parseInt(carrot.inventory) / parseInt(carrot.carrot_unit))) * parseInt(carrot.carrot_unit)  + " هویج به " + (Math.floor(parseInt(carrot.inventory) / parseInt(carrot.carrot_unit)) * parseInt(carrot.carrot_toman)).toLocaleString() + " تومان" +
                    "<br>" +
                    "آیا اطمینان دارید؟",
                imageUrl: PUBLIC_URL_SERVER + '/images/icons/carrot_logo.png',
                imageHeight: 100,
                imageAlt: 'هویج',
                confirmButtonText: "تبدیل",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    callApiCarrotExchange();
                }
            });
        }
	    else {
            btnOkSingle.fire({
                text: "حداقل امتیاز قابل تبدیل " + carrot.carrot_unit + " هویج می باشد.",
                imageUrl: PUBLIC_URL_SERVER + '/images/icons/carrot_logo.png',
                imageHeight: 100,
                imageAlt: 'هویج',
                confirmButtonText: "باشه",
            });
	    }   
    };

    const callApiCarrotExchange = () => {
    	dispatch(actionChangeLoaderMyWallet(true));

    	/*
		function apiGetListTransactions() vase in neveshte shode bude ke vaghti tarakoneshharo scrol mikonim payin api ro call kone 15 ta recorde badi ro begire
		vase hamin oonja offset +15 mishe
		hala chon tabdile havij be toman dare anjam mishe va 1 recorde jadid be tarakoneshha ezafe mishe, ma offset ro mikonim -15 ke dar function fogh +15 beshe yani beshe 0
		dar vaghe mikhaym az satre aval namayesh bede tarakonesh haro
    	*/

    	axios({
            method: 'get',
            url: BASE_URL + EXCHANGE_CARROT,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if (response.data.status === 'ok') 
            	apiGetListTransactions(-0);
            else
            	dispatch(actionChangeLoaderMyWallet(false));
        });
    }

    const apiGetListTransactions = (default_offset = offset) => {
    	console.log("aziz joon: " + default_offset);
            axios({
                method: 'post',
                url: BASE_URL + USERS_TRANSACTIONS_POST,
                data: qs.stringify({offset: default_offset}),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
            }).then((response) => {
                if (response.data.status === 'ok') {
                	const {transactions: transactions_api, total: total_api, total_rows: total_rows_api, carrot} = response.data;
                	if(default_offset === -0) // ghabliya pak beshe va faghat jadid namayesh dade beshe
                    	dispatch(actionChangeDataWallet(transactions_api, total_api, total_rows_api, (default_offset + 15), carrot));
                    else // inayi ke jadid oomade entehaye ghabliya namayesh dade beshe
                    	dispatch(actionChangeDataWallet(transactions.concat(transactions_api), total_api, total_rows_api, (default_offset + 15), carrot));
                }

                dispatch(actionChangeLoaderMyWallet(false));
            });
    };

    const openModalMyCarrotWallet = () => {
        apiGetListCarrotTransactions();
        dispatch(handelOpenModalMyCarrotWallet());
    };


    const apiGetListCarrotTransactions = () => {
        dispatch(actionChangeLoaderMyCarrotWallet(true));
        axios({
            method: 'post',
            url: BASE_URL + USERS_CARROT_TRANSACTIONS_POST,
            data: qs.stringify({
                offset: 0
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            const {
                status,
                transactions: transactions_api,
                total: total_api,
                total_rows: total_rows_api
            } = response.data;
            if (status === 'ok') {
                dispatch(actionChangeDataCarrotWallet(transactions_api, total_api, total_rows_api, 15));
                dispatch(actionChangeLoaderMyCarrotWallet(false));
            }
        });
    };

    const clickInfoCarrotInventory = () => {
        btnOkSingle.fire({
            text: "با  هر " + parseInt(carrot.guide.min_purchase).toLocaleString() + " تومان   خرید ، " + carrot.guide.carrot_gift + "  هویج دریافت خواهید کرد.",
            imageUrl: PUBLIC_URL_SERVER + '/images/icons/carrot_logo.png',
            imageHeight: 100,
            imageAlt: 'هویج',
            confirmButtonText: "باشه",
        });
    }

    const clickInfoCarrotExchange = () => {
        btnOkSingle.fire({
            html: "سطح کاربری برنز: هر " + carrot.carrot_unit + " هویج معادل  " + parseInt(carrot.guide.bronze_level).toLocaleString() + " تومان " +
                "<br />" +
                "سطح کاربری  نقره‌ای: هر " + carrot.carrot_unit + " هویج معادل  " + parseInt(carrot.guide.silver_level).toLocaleString() + " تومان " +
                "<br />" +
                "سطح کاربری طلایی: هر " + carrot.carrot_unit + " هویج معادل  " + parseInt(carrot.guide.gold_level).toLocaleString() + " تومان " ,
            imageUrl: PUBLIC_URL_SERVER + '/images/icons/carrot_logo.png',
            imageHeight: 100,
            imageAlt: 'هویج',
            confirmButtonText: "باشه",
            confirmButtonColor: "#42b029",
        });
    }

    return (
        <div>
            <BaseModal title={'کیف پول من'}
                       show={statusShow}
                       dialogClassName={''}
                       handleClose={handleClose}>
                <Modal.Body id={"scrollableDiv"}>
                    {!loader ?
                    <div>
                    	<div className="box-carrot">
                    		امتیاز شما:  {carrot.inventory} <img src={ic_carrot} style={{cursor: "pointer"}} onClick={openModalMyCarrotWallet} alt={carrot.inventory} width={24} height={24} /> <FaInfoCircle className='icon-info-my-carrot-inventory ml-2' onClick={clickInfoCarrotInventory} />
                    		<br/>
                    		هر  {carrot.carrot_unit} هویج شما {parseInt(carrot.carrot_toman).toLocaleString()} تومان <FaInfoCircle className='icon-info-my-carrot-inventory ml-2' onClick={clickInfoCarrotExchange} />
                    		<br/>
                    		<span className={"px-1"} style={{color: "#42b029", cursor: "pointer", border: "1px solid", borderColor: "rgb(66, 176, 41)", borderRadius: "5px"}} onClick={handelCarrotExchange}>تبدیل هویج به پول</span>
                    	</div>
                        <div><TitlesModals>تراکنش ها</TitlesModals></div>
                        {transactions.length > 0 ?
                            <InfiniteScroll
                                dataLength={offset}
                                next={apiGetListTransactions}
                                hasMore={transactions.length < total_rows}
                                loader={<h5 className={'text-center text-success mt-1'}>درحال بارگزاری ...</h5>}
                                scrollableTarget="scrollableDiv"
                            >
                                {transactions.map((transaction, index) => (
                                    <div key={index} className={'pb-3 mt-1 border-bottom'}>
                                        <div>
                                            <span className={'ml-2'}><b>{transaction.description}</b></span>
                                            <span className={`float-left mr-2 ${transaction.amount >= 0 ? 'text-success' : 'text-danger'}`}>
                                                <b dir="ltr">{transaction.amount.toLocaleString()}</b> تومان
                                            </span>
                                        </div>
                                        <div>
                                            <span className={'float-left mr-2'}><b>{transaction.date}</b></span>
                                        </div>
                                        <br/>
                                    </div>
                                ))}
                            </InfiniteScroll>
                            :
                            <div className={'box-not-find-transaction-modal-wallet'}>
                                <div className={'not-find-transaction-modal-wallet'}>
                                    <FaTimesCircle className={'icon-not-find-transaction-modal-wallet'}/>
                                    <p>تراکنشی وجود ندارد</p>
                                </div>
                            </div>
                        }

                    </div>
                        : <LoaderModals/>}
                </Modal.Body>
                <Modal.Footer>
                    <div className={'base-box-add-price-in-modal-my-wallet'}>
                        <div className={'add-price-in-modal-my-wallet'} onClick={handelAddPrice}>
                            <FaPlus className={'icon-plus-add-price-modal-wallet'}/>
                            <span className={'txt-plus-add-price-modal-wallet'}>افزایش اعتبار</span>
                        </div>
                    </div>
                    <Button variant="success" className={'base-btn-green'} block>
                        <span className={'float-right'}>موجودی کیف پول</span>
                        <span className={'float-left price-show-data-btn-footer-modal-wallet base-green-dark'}>
                            <span style={{unicodeBidi: "bidi-override", direction: "ltr"}}>{total.toLocaleString()}</span>
                            <span> تومان </span>
                        </span>
                    </Button>
                </Modal.Footer>
            </BaseModal>
        </div>
    );
};

export default memo(ModalMyWallet);
